import { get } from 'lodash';

import { getTranslatedString } from '@skinsoft/ui';
import { ConditionReport } from './condition-report-data-store';

export const id = (conditionReport: ConditionReport) => get(conditionReport, 'id');

export const media = (conditionReport: ConditionReport) => {
    const otherMedia = get(conditionReport, 'associatedMedias.mediaFiles.0.mediaId', null);
    const third = get(conditionReport, 'associatedMedias.third');
    const second = get(conditionReport, 'associatedMedias.second');
    const first = get(conditionReport, 'associatedMedias.first');

    return first || second || third || otherMedia;
};

export const manifestation = (conditionReport: ConditionReport) =>
    get(conditionReport, 'linkToManifestation.referentManifestation');

// For search features
export const title = (conditionReport: ConditionReport, locale: string) =>
    getTranslatedString(get(conditionReport, 'translatedTitle', ''), locale) as string;

// ============

export const medias = (conditionReport: ConditionReport) => {
    const mediasArray = get(conditionReport, 'associatedMedias.medias');
    return mediasArray ? mediasArray.map(mediaElement => mediaElement.mediaId) : [];
};

export const firstMedia = (conditionReport: ConditionReport) => get(conditionReport, 'associatedMedias.first')

export const referenceNumber = (conditionReport: ConditionReport) =>
    get(conditionReport, 'conditionReportCS.referenceNumber');

export const technicsAndMaterials = (conditionReport: ConditionReport, locale: string) =>
    getTranslatedString(get(conditionReport, 'conditionReportCS.technicsAndMaterials[0]'), locale);

export const originalIdentifier = (conditionReport: ConditionReport) =>
    get(conditionReport, 'managementData.originalIdentifier');

export const reportReason = (conditionReport: ConditionReport, locale: string) =>
    getTranslatedString(get(conditionReport, 'conditionReportCS.reportReason'), locale);

export const reportType = (conditionReport: ConditionReport) =>
    get(conditionReport, 'conditionReportCS.reportType')


export const location = (conditionReport: ConditionReport, locale: string) =>
    getTranslatedString(get(conditionReport, 'conditionReportCS.location'), locale);

export const date = (conditionReport: ConditionReport) =>
    get(conditionReport, 'conditionReportCS.reportDate.startInterval.dateTxt');

export const generalState = (conditionReport: ConditionReport, locale: string) =>
    getTranslatedString(get(conditionReport, 'conditionReportCS.generalState'), locale)

export const defects = (conditionReport: ConditionReport) =>
    get(conditionReport, 'conditionReportCS.alterationDetails', []) || [];

export const recommendations = (conditionReport: ConditionReport, locale: string) =>
    getTranslatedString(get(conditionReport, 'conditionReportCS.recommendations'), locale)

export const workflowState = (conditionReport: ConditionReport): string =>
    get(conditionReport, "workflowSchema.currentState.name") as string;

export const comments = (conditionReport: ConditionReport, locale: string): string =>
    getTranslatedString(get(conditionReport, "conditionReportCS.comments[0]"), locale) as string

export const interventionsToSchedule = (conditionReport: ConditionReport) =>
    get(conditionReport, "conditionReportCS.predictInterventions")

export const stateOfConservation = (conditionReport: ConditionReport) =>
    get(conditionReport, "conditionReportCS.stateOfConservations")

export const treatmentPriority = (conditionReport: ConditionReport) =>
    get(conditionReport, "conditionReportCS.treatmentPriority")

export const involvedItem = (conditionReport: ConditionReport) =>
    get(conditionReport, 'conditionReportCS.linkableItem.linkableItem');